import { useContext } from 'react';

import { INotificationsContext, NotificationsContext } from './NotificationsContext';

export const useNotifications = (): INotificationsContext => {
	const context = useContext(NotificationsContext);

	if (!context) {
		throw new Error('useNotifications must be used within NotificationsProvider');
	}

	return context;
};
